import React, { useCallback, useEffect, useState } from 'react'
import HOC from '../../components/HOC/HOC'
import { deleteApi, getApi } from '../../Repository/Api';
import endPoints from '../../Repository/apiConfig';
import Pagination from '../../components/Pagination/Pagination';

import styles from '../../css/style.module.css';

import { RiDeleteBin6Line } from "react-icons/ri";
import { RiVerifiedBadgeFill } from "react-icons/ri";
import { FaStar } from "react-icons/fa6";
import { IoSearchSharp } from "react-icons/io5";
import { MdOutlineRemoveRedEye } from "react-icons/md";


import img from '../../assest/img7.png'
import img2 from '../../assest/loading1.gif'

import { Link } from 'react-router-dom';
import { DeleteSuccessfullyModal, SuccessfullyModal } from '../../components/Modals/Modals';




const columns = [
  'S.no',
  'ID',
  'Name',
  'Job Role',
  'Unique Id',
  // 'Password',
  'GST Number',
  'Rating',
  'Gender',
  'Wallet',
  'Action'
];




const ActiveEmployee = () => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [staffdata, setStaffData] = useState([])
  const [loading, setLoading] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [search, setSearch] = useState('')
  const [pagination, setPagination] = useState({
    limit: 10,
    totalPages: 1,
    page: 1,
    hasPrevPage: false,
    hasNextPage: false,
  });


  const fetchData = useCallback(async () => {
    await getApi(endPoints.getallActivestaff(pagination.page, pagination.limit, search), {
      setResponse: setStaffData,
      setLoading,
      errorMsg: 'Failed to fetch staff!'
    });
  }, [pagination.page, pagination.limit, search]);


  useEffect(() => {
    setPagination((prevPagination) => ({
      ...prevPagination,
      totalPages: staffdata?.data?.totalPages,
      hasPrevPage: staffdata?.data?.hasPrevPage,
      hasNextPage: staffdata?.data?.hasNextPage,
    }));
  }, [staffdata]);


  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleDelete = async () => {
    if (!selectedUser) return;

    await deleteApi(endPoints.deleteUser(selectedUser), {
      setLoading,
      // successMsg: 'Category deleted successfully!',
      errorMsg: 'Failed to delete staff!'
    });

    fetchData();
    setShowDeleteModal(false);
    setShowSuccessModal(true);
    setTimeout(() => setShowSuccessModal(false), 2000);
  };

  const openDeleteModal = (categoryId) => {
    setSelectedUser(categoryId);
    setShowDeleteModal(true); // Open confirm delete modal
  };

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setPagination({ ...pagination, page: 1 }); // Reset to the first page on search
  };


  const routeMapping = {
    Registered: "/staff-management/registered",
    'Active Employee': "/staff-management/active-employee",
    'Track Employee': "/staff-management/track-employee",
  };


  return (
    <>
      <DeleteSuccessfullyModal
        show={showDeleteModal}
        handleClose={() => setShowDeleteModal(false)}
        handleConfirm={handleDelete}
        text="delete Employee"
      />
      <SuccessfullyModal
        show={showSuccessModal}
        handleClose={() => setShowSuccessModal(false)}
        text="Successfully Deleted"
      />
      <div className={styles.jobmanagementCotainer}>
        <div className={styles.jobtoppart}>
          <div className={styles.pagetitle}>
            <h6>User Management</h6>
            <div className={styles.searchbarnav}>
              <IoSearchSharp color='#8A8A8A' size={20} />
              <input
                type="search"
                placeholder="Search"
                value={search}
                onChange={handleSearchChange}
              />
            </div>
          </div>
          <div className={styles.rightbuttons}>

          </div>
        </div>
        <div className={styles.jobselectcontainer}>
          <div className={styles.jobStatusContainer}>
            {['Registered', 'Active Employee', 'Track Employee'].map((item, index) => (
              <Link key={index} to={routeMapping[item]} className={styles.link}>
                <p
                  className={
                    item === 'Active Employee'
                      ? styles.jobOptionTrueactive
                      : styles.jobOptionnotactive
                  }
                >
                  {item}
                </p>
              </Link>
            ))}
          </div>
        </div>
        <div className={styles.jobchildcontainer}>
          <div className={styles.tablecontainer}>
            <table className={styles.table1}>
              <thead>
                <tr>
                  {columns.map((label, index) => (
                    <th key={index} className={styles.tableHeader}>{label}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {loading ?
                  <tr>
                    <td colSpan="12" style={{ textAlign: "center", padding: "1rem" }}>
                      <img src={img2} alt="" width={100} height={100} />
                    </td>
                  </tr>
                  :
                  staffdata?.data?.docs?.length === 0 ?
                    <tr>
                      <td colSpan="12" style={{ textAlign: "center", padding: "1rem" }}>
                        No data available.
                      </td>
                    </tr>
                    :
                    staffdata?.data?.docs?.map((register, rowIndex) => (
                      <tr key={rowIndex} className={styles.tableRow}>
                        <td className={styles.tableCell}>{rowIndex + 1}</td>
                        <td className={styles.tableCell}>
                          {register.Id}
                        </td>
                        <td className={styles.tableCell}>
                          <div className={styles.tableprofilecontainer}>
                            <div className={styles.tablecellprofile}>
                              <div className={styles.tablecellprofileimg}>
                                <img src={register.image ? register.image : img} alt="" />
                              </div>
                              <div className={styles.tableprofileverified}>
                                <RiVerifiedBadgeFill color='#F05423' size={20} />
                              </div>
                            </div>
                            {register.firstName} {register.lastName}
                          </div>
                        </td>
                        <td className={styles.tableCell}>
                          <ul>
                            {
                              register?.subcategoryId?.length === 0 ?
                                <option value="">No Role</option>
                                :
                                register?.subcategoryId?.map((cat) => (
                                  <li>{cat?.name}</li>
                                ))}
                          </ul>
                        </td>
                        <td className={styles.tableCell}>{register.uniqueId}</td>
                        {/* <td className={styles.tableCell}></td> */}
                        <td className={styles.tableCell}>{register.gstNo}</td>
                        <td className={styles.tableCell}>{register.ratings} <FaStar color='gold' /></td>
                        <td className={styles.tableCell}>{register.gender}</td>
                        <td className={styles.tableCell}>{register.wallet}</td>
                        <td>
                          <div className={styles.tableaction}>
                            <Link to={`/staff-management/registered/staffprofile/${register?._id}`}>
                              <MdOutlineRemoveRedEye size={20} />
                            </Link>
                            <RiDeleteBin6Line
                              size={20}
                              onClick={() => openDeleteModal(register._id)}
                              style={{ cursor: "pointer", color: "#d9534f" }}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
              </tbody>
            </table>
          </div>
          <Pagination
            limit={pagination.limit}
            totalPages={pagination.totalPages}
            page={pagination.page}
            hasPrevPage={pagination.hasPrevPage}
            hasNextPage={pagination.hasNextPage}
            onPageChange={(newPage) => setPagination({ ...pagination, page: newPage })}
          />
        </div>
      </div>
    </>
  )
}

export default HOC(ActiveEmployee)